import * as mapping from "knockout.mapping";
import * as ko from "knockout";
import * as $ from "jquery";
import { AlertMessageModel } from "../../Models/NewspaperRequestModels/alertMessageModel";
import { Address } from "../../Models/NewspaperRequestModels/address";
import { Newspaper } from "../../Models/NewspaperRequestModels/newspaper";
import { OrderType } from "../../Models/NewspaperRequestModels/orderType";
import { NewspaperRequestAddressBlock } from "../../Models/NewspaperRequestModels/newspaperRequestAddressBlock";
import { SessionOptions } from "../../Models/NewspaperRequestModels/sessionOptions";

class NewspaperRequestPageViewModel {
    dropdownsOptions: any;
    dataLists: any;
    settingOptions: any;

    subscriptionId: any;
    newspaperRequestAddressBlocks: any

    periodString: string;
    isEditablePanel: any;
    hasEditable: any;
    alertMessage: any;
    errorVisible: any;
    errorMessage: any;
    notificationVisible: any;
    notificationMessage: any;

    sessionOptions: any;
    buttonAction: any;
    
    constructor(params: any) {

        this.buttonAction = ko.observable<number>(params.data.ButtonAction);

        this.alertMessage = ko.observable<AlertMessageModel>(new AlertMessageModel);
        this.errorVisible = ko.observable<boolean>(false);
        this.errorMessage = ko.observable<string>("");
        this.notificationVisible = ko.observable<boolean>(false);
        this.notificationMessage = ko.observable<string>("");

        this.subscriptionId = ko.observable<number>(params.data.SubscriptionId);
        this.newspaperRequestAddressBlocks = ko.observableArray<NewspaperRequestAddressBlock>();

        this.sessionOptions = new SessionOptions();

        //console.log(JSON.parse(JSON.stringify(ko.toJS(params.data))));

        // DropDown Options mapping
        let mappingOptionsForDropdownsOptions = {
            'AddressDropdownOptions': {
                create: (args: any) => {
                    return new Address(args.data);
                }
            },
            'NewspaperDropdownOptions': {
                create: (args: any) => {
                    return new Newspaper(args.data);
                }
            },
            'OrderTypeDropdownOptions': {
                create: (args: any) => {
                    return new OrderType(args.data);
                }
            }
        }

        this.dropdownsOptions = mapping.fromJS(params.data, mappingOptionsForDropdownsOptions);

        // Session Options
       
        this.sessionOptions.SelectedAddressId(params.data.SelectedAddressId);
        this.sessionOptions.SelectedIsNewRequest(params.data.SelectedIsNewRequest);
        this.sessionOptions.SelectedIsFullAddressChange(params.data.SelectedIsFullAddressChange);
        this.sessionOptions.SelectedRecipientName(params.data.SelectedRecipientName);
        
        // Recorded Lists mapping

        let mappingOptionsForData = {
            'NewspaperRequestAddressBlocks': {
                create: (args: any) => {
                    return new NewspaperRequestAddressBlock(args.data);
                }
            }
        };

        this.dataLists = mapping.fromJS(params.data, mappingOptionsForData);

        this.newspaperRequestAddressBlocks = this.dataLists.NewspaperRequestAddressBlocks;
        //console.log(JSON.parse(JSON.stringify(ko.toJS(this.newspaperRequestAddressBlocks))));

        // Others
        this.periodString = params.data.Year + ". " + params.data.Quarter + ". negyedév";
        this.isEditablePanel = ko.observable<boolean>(params.IsEditable);

        this.hasEditable = ko.pureComputed(() => {
            
            for (let site of this.newspaperRequestAddressBlocks()) {
                if (site.hasEditableTable()) {
                    return true;
                }
            }
            return false;
        });

        // stop navigation with popup message when editing
        $(window).on("beforeunload", () => {
            if (this.hasEditable()) {
                return true;
            }
        });
    }
}

export class NewspaperRequestPageComponent {
    constructor() {
        return {
            viewModel: NewspaperRequestPageViewModel,
            template: require("text-loader!./newspaperRequestPageView.html")
        }
    }
}